const initialState = {     
      statusType: 'ALL',
	filterText: '',
      emailAddressId: '',
      emailAddressName: '',
      phoneNumberId: '',
      phoneNumberName: '',
      userId: '',
      userName: ''
}

const alertListFiltersReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_ALERT_LIST_FILTERS':
                  return {
                        ...state,
                        statusType: action.filters.statusType,
                        filterText: action.filters.filterText,
                        emailAddressId: action.filters.emailAddressId,
                        phoneNumberId: action.filters.phoneNumberId,
                        userId: action.filters.userId
                  }
            case 'SET_ALERT_LIST_EMAIL_ADDRESS_FILTER':
                  return {
                        ...state,
                        emailAddressId: action.emailAddressFilter.emailAddressId,
                        emailAddressName: action.emailAddressFilter.emailAddressName
                  }
            case 'SET_ALERT_LIST_PHONE_NUMBER_FILTER':
                  return {
                        ...state,
                        phoneNumberId: action.phoneNumberFilter.phoneNumberId,
                        phoneNumberName: action.phoneNumberFilter.phoneNumberName
                  }
            case 'SET_ALERT_LIST_USER_FILTER':
                  return {
                        ...state,
                        userId: action.userFilter.userId,
                        userName: action.userFilter.userName
                  }
            case 'UPDATE_CURRENT_USER':
            case 'LOGOUT_USER':
                  return {
                        statusType: 'ALL',
                        filterText: '',
                        emailAddressId: '',
                        emailAddressName: '',
                        phoneNumberId: '',
                        phoneNumberName: '',
                        userId: '',
                        userName: ''
                  }
            default:
                  return state;
      }

};
export default alertListFiltersReducer;
